import React from 'react';
import { Link } from 'react-router-dom';
import EditButton from '../../buttons/EditButton';

const NavigateActionColumn: React.FC<{ to: string }> = ({ to }) => {
  return <EditButton variant="outline-primary" label="Edit" as={Link} to={to} />;
};

export default NavigateActionColumn;
